import { useMutation, useQueryClient } from '@tanstack/react-query';
import { isArray } from 'lodash';

import { useLoader } from 'Store/loader';
import { useToast } from 'Store/toast';
import { useModal } from 'Store/modal';
import postStartBreak from 'Api/monitoring/postStartBreak';
import { postStartBreakText } from 'Const/monitoring/domain';

import postStartBreakPayload from './model/request/postStartBreakPayload';

const usePostStartBreak = () => {
  const { onShowLoader, onResetLoader } = useLoader();
  const queryClient = useQueryClient();
  const { onResetModal } = useModal();

  const { onOpenToast } = useToast();

  return useMutation({
    mutationFn: async (formData) => {
      const payload = postStartBreakPayload(formData);

      const result = await postStartBreak(payload);

      return result;
    },
    onMutate: () => onShowLoader({ variant: 'loader-primary' }),
    onSuccess: async () => {
      onResetModal();

      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['monitoring-operator-status'] }),
        queryClient.invalidateQueries({ queryKey: ['break'] }),
        queryClient.invalidateQueries({ queryKey: ['daily-log'] }),
      ]);
    },
    onError: (error) => {
      const errorMessage = isArray(error?.response?.data?.errors) ? error?.response?.data?.errors[0]?.message : postStartBreakText.defaultErrorMessageText;
      onOpenToast({ status: 'error', description: errorMessage, duration: 5, alwaysShow: false });
    },
    onSettled: () => {
      onResetLoader();
    },
  });
};

export default usePostStartBreak;
